import api from "@/services/api";

const state = {
  profile: null,
};

const getters = {
  profile: (state) => state.profile,
};

const mutations = {
  SET_PROFILE(state, payload) {
    state.profile = payload;
  },
};

const actions = {
  async getProfile({ commit }) {
    try {
      const res = await api.get("/business/profile");
      commit("SET_PROFILE", res.data);
    } catch (error) {
      console.error("Error fetching profile:", error.message);
      throw error;
    }
  },

  async saveProfile({ dispatch }, payload) {
    try {
      await api.put("/business/profile", payload);
      await dispatch("getProfile");
    } catch (error) {
      console.error("Error saving profile:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};